import _Range from "./Slider";
import _AddressAutoComplete from "./AddressAutoComplete";
import _LocationPicker from "./LocationPicker";

const DeprecatedForm = {
  Range: _Range,
  AddressAutoComplete: _AddressAutoComplete,
  LocationPicker: _LocationPicker,
};

export default DeprecatedForm;
